import { render, staticRenderFns } from "./LanguageIndicator.vue?vue&type=template&id=d6a614f4"
import script from "./LanguageIndicator.vue?vue&type=script&lang=js"
export * from "./LanguageIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports